jQuery(document).ready(function($) {
  // reportカテゴリの場合は処理しない
  if ($('#reportPosts').length) {
    return;
  }

  // categoryAjaxDataが存在しない場合は処理しない
  if (typeof categoryAjaxData === 'undefined') {
    return;
  }

  let currentPage = 1;
  let isLoading = false;
  const $moreBtn = $('.more_btn');
  const $archiveContent = $('.archive_content');
  
  // カテゴリIDを取得（0の場合は全カテゴリを意味する）
  const categoryId = categoryAjaxData.categoryId || 0;

  // 初期表示時、既に表示されている記事数を確認
  const initialPostsCount = $archiveContent.find('.archive_item').length;
  if (initialPostsCount < 10) {
    $moreBtn.hide();
    return;
  }

  // more_btnクリックイベント
  $moreBtn.on('click', function(e) {
    e.preventDefault();
    
    if (isLoading) {
      return;
    }

    isLoading = true;
    currentPage++;
    
    $moreBtn.text('読み込み中...');
    $moreBtn.addClass('loading');

    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'load_category_posts',
        nonce: categoryAjaxData.nonce,
        page: currentPage,
        category_id: categoryId
      },
      success: function(response) {
        if (response.success && response.data.posts_html) {
          // 追加前の記事数を保存
          const beforeCount = $archiveContent.find('.archive_item').length;
          
          // 記事を追加（more_btnの前に挿入）
          $moreBtn.before(response.data.posts_html);
          
          // 追加された最初の要素を取得
          const $newItems = $archiveContent.find('.archive_item');
          const $firstNewItem = $newItems.eq(beforeCount);
          
          // 追加された最初の要素までスクロール
          if ($firstNewItem.length) {
            const offsetTop = $firstNewItem.offset().top;
            const headerHeight = $('#header').outerHeight() || 0;
            const scrollPosition = offsetTop - headerHeight - 20; // ヘッダー分と余白を引く
            
            $('html, body').animate({
              scrollTop: scrollPosition
            }, 500);
          }
          
          // これ以上記事がない場合はボタンを非表示
          if (!response.data.has_more) {
            $moreBtn.hide();
          } else {
            $moreBtn.text('more');
            $moreBtn.removeClass('loading');
          }
        } else {
          $moreBtn.text('more');
          $moreBtn.removeClass('loading');
          alert('記事の読み込みに失敗しました');
        }
        isLoading = false;
      },
      error: function() {
        $moreBtn.text('more');
        $moreBtn.removeClass('loading');
        alert('記事の読み込みに失敗しました');
        isLoading = false;
        currentPage--; // ページ番号を戻す
      }
    });
  });
});

